/**
 * BudgetReleaseService
 * Monthly cashflow release schedule of a budget (nested route). ADVISORY only —
 * releases inform approvers, they never block procurement.
 * Route: api/budgets/{budgetId}/releases
 */
export class BudgetReleaseService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config?.servicePath ?? BudgetReleaseService.DEFAULT_SERVICE_PATH;
    }
    buildUrl(budgetId, path) {
        const base = `${this.servicePath}/api/budgets/${budgetId}/releases`;
        const url = path ? `${base}/${path}` : base;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** The budget's release schedule rows (ordered by periodStart). */
    async getByBudget(budgetId) {
        const response = await this.getByBudgetRaw(budgetId);
        return response.data ?? [];
    }
    getByBudgetRaw(budgetId) {
        return this.http.get(this.buildUrl(budgetId));
    }
    /** Materialize the schedule from a rule (1 Percent / 2 FixedAmount per month). */
    async generate(budgetId, body) {
        const response = await this.generateRaw(budgetId, body);
        return response.data ?? [];
    }
    generateRaw(budgetId, body) {
        return this.http.post(this.buildUrl(budgetId, 'generate'), body);
    }
    /** Create or replace a single release month (admin edits). */
    async upsert(budgetId, body) {
        const response = await this.upsertRaw(budgetId, body);
        if (!response.data)
            throw new Error(`Failed to upsert release for budget ${budgetId}`);
        return response.data;
    }
    upsertRaw(budgetId, body) {
        return this.http.post(this.buildUrl(budgetId), body);
    }
    /** Update an existing release row. */
    async update(budgetId, releaseId, body) {
        const response = await this.updateRaw(budgetId, releaseId, body);
        if (!response.data)
            throw new Error(`Failed to update budget release ${releaseId}`);
        return response.data;
    }
    updateRaw(budgetId, releaseId, body) {
        return this.http.put(this.buildUrl(budgetId, String(releaseId)), body);
    }
    /** Delete a release row. */
    async delete(budgetId, releaseId) {
        const response = await this.deleteRaw(budgetId, releaseId);
        return response.success;
    }
    deleteRaw(budgetId, releaseId) {
        return this.http.delete(this.buildUrl(budgetId, String(releaseId)));
    }
}
BudgetReleaseService.DEFAULT_SERVICE_PATH = 'budgets';
//# sourceMappingURL=BudgetReleaseService.js.map